import { render, staticRenderFns } from "./RegionalAccounts.vue?vue&type=template&id=34e2a798&"
import script from "./RegionalAccounts.vue?vue&type=script&lang=js&"
export * from "./RegionalAccounts.vue?vue&type=script&lang=js&"
import style0 from "./RegionalAccounts.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports